export default function SentryExamplePage() {
  const triggerError = () => {
    const currentDate = new Date().toISOString();
    throw new Error(`Erro de teste do Sentry - ${currentDate}`);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
      <div className="w-full max-w-md bg-white rounded-xl shadow-md p-8 text-center">
        <h1 className="text-2xl font-semibold text-gray-800">Sentry Example</h1>
        <p className="mt-2 text-sm text-gray-500">
          Clique no botão abaixo para disparar um erro para o Sentry
        </p>

        <button
          onClick={triggerError}
          className="mt-6 inline-flex items-center justify-center px-5 py-3 rounded-lg bg-red-600 text-white font-medium shadow hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
        >
          Disparar Erro
        </button>
      </div>
    </div>
  );
}
